import { useState } from 'react';
import { useDrawer } from '../../../shared/drawer';
import { PageBody } from '../../../elements/page-body';
import { Table } from '../../../elements/table';
import { TiposMultasForm } from './tipos-multas-form';


export const TiposMultas = () => {
    const { open, close } = useDrawer();
    const [refresh, setRefresh] = useState<string | null>(null);




    const handleNewAction = () => {
        open('common.label.new-tipos-multa', <TiposMultasForm close={handleClose} />);
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };


    return (
        <PageBody
            newAction={handleNewAction}
            title={'common.label.tipos-multa'}
            newActionTitle={'common.label.new-tipos-multa'}
        >
            <>
                <Table
                    path="/fleet/sanction-types/"
                    deletePath="/fleet/sanction-types/"
                    callBeforeDrawerClosed={handleClose}
                    Form={TiposMultasForm}
                    withPagination
                    refresh={refresh}
                    headers={[
                        {
                            key: 'name',
                            label: 'common.form-label.name'
                        },
                        {
                            key: 'description',
                            label: 'common.form-label.descripcion'
                        }
                    ]}
                />
            </>
        </PageBody>
    );
};